<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog persistent
                v-model="$store.getters.bookFileModal"
                max-width="500">

            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Αρχεία
                </v-card-title>

                <v-card-text class="mt-5">
                    <v-row>
                        <v-col>
                            <v-file-input ref="pathToCover" v-model="files1" accept=".gif, .jpeg, .jpg" :disabled="disableAllFields ? true : $store.getters.fileUpload ? true : false" @change="saveCover" label="Εξώφυλλο" outlined dense></v-file-input>
                        </v-col>
                        <v-col>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="!disableIcon(cover) ? true : $store.getters.fileUpload ? true : false" v-on="on" large class="ml-5" color="primary" @click="showBook(1)">visibility</v-icon>
                                </template>
                                <span>Επισκόπηση</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="disableAllFields ? true : !disableIcon(cover) ? true : $store.getters.fileUpload ? true : false" @click="deletePathFile('cover')" v-on="on" large class="ml-5" color="red">delete</v-icon>
                                </template>
                                <span>Διαγραφή</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-file-input ref="pathToBackCover" v-model="files2" accept=".gif, .jpeg, .jpg" :disabled="disableAllFields ? true : $store.getters.fileUpload ? true : false" @change="saveBackCover" label="Οπισθόφυλλο" outlined dense></v-file-input>
                        </v-col>
                        <v-col>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="!disableIcon(backCover) ? true : $store.getters.fileUpload ? true : false" v-on="on" large class="ml-5" color="primary" @click="showBook(2)">visibility</v-icon>
                                </template>
                                <span>Επισκόπηση</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="disableAllFields ? true : !disableIcon(backCover) ? true : $store.getters.fileUpload ? true : false" @click="deletePathFile('backcover')" v-on="on" large class="ml-5" color="red">delete</v-icon>
                                </template>
                                <span>Διαγραφή</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-file-input ref="pathToToc" v-model="files3" accept=".pdf" :rules="rulesOfPDF" :disabled="disableAllFields ? true : $store.getters.fileUpload ? true : false" @change="saveToc" label="Πίνακας Περιεχομένων" outlined dense></v-file-input>
                        </v-col>
                        <v-col>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="!disableIcon(toToc) ? true : $store.getters.fileUpload ? true : false" v-on="on" large class="ml-5" color="primary" @click="showBook(3)">visibility</v-icon>
                                </template>
                                <span>Επισκόπηση</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="disableAllFields ? true : !disableIcon(toToc) ? true : $store.getters.fileUpload ? true : false" @click="deletePathFile('toc')" v-on="on" large class="ml-5" color="red">delete</v-icon>
                                </template>
                                <span>Διαγραφή</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-file-input ref="pathToChapter" v-model="files4" accept=".pdf"  :rules="rulesOfPDF" :disabled="disableAllFields ? true : $store.getters.fileUpload ? true : false" @change="saveChapter" label="Ενδεικτικό Απόσπασμα" outlined dense></v-file-input>
                        </v-col>
                        <v-col>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="!disableIcon(toChapter) ? true : $store.getters.fileUpload ? true : false" v-on="on" large class="ml-5" color="primary" @click="showBook(4)">visibility</v-icon>
                                </template>
                                <span>Επισκόπηση</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="disableAllFields ? true : !disableIcon(toChapter) ? true : $store.getters.fileUpload ? true : false" @click="deletePathFile('chapter')" v-on="on" large class="ml-5" color="red">delete</v-icon>
                                </template>
                                <span>Διαγραφή</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-progress-linear
                            v-if="$store.getters.fileUpload"
                            color="primary"
                            indeterminate
                            rounded
                            height="6"
                    ></v-progress-linear>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="$store.getters.fileUpload"
                            color="primary"
                            text
                            @click="closeModal">
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>

    import {eventBus} from "../../main";
    import utils from "../../utilities"
    import request from "../../requests"

    export default {
        name: "BookFiles",
        data: () => ({
            utils,
            progress: false,
            pathToCoverValue: null,
            pathToBackcoverValue: '',
            pathToTOCValue: '',
            pathToChapterValue: '',
            rulesOfPDF: [
                value => !value || value.size < 34000000 || 'Αρχείο pdf (.pdf) μεγέθους έως 34MB!',
            ],
            files1: [],
            files2: [],
            files3: [],
            files4: [],

        }),
        props: {
            disableAllFields: Boolean,
            pathToCover: String,
            pathToBackcover: String,
            pathToTOC: String,
            pathToChapter: String,
            bookId: Number
        },

        methods: {

            closeModal() {
                this.files1 = null;
                this.files2 = null;
                this.files3 = null;
                this.files4 = null;
                this.$store.commit('setBookFileModal', false);
            },

            saveCover(file) {
                this.upLoadFile(file, 'cover');
            },

            saveBackCover(file) {
                this.upLoadFile(file, 'backcover');
            },

            saveToc(file){
                this.upLoadFile(file, 'toc');
            },

            saveChapter(file) {
                this.upLoadFile(file, 'chapter');
            },

            upLoadFile(file, type){

                if (file != undefined) {
                    const formData = new FormData();
                    formData.append(type, file);
                    var token = utils.getLocalStorage('token');
                    if (token != null) {
                        this.$store.commit('setFileUpload', true);
                        request.upLoadFileToServlet(token, type, this.$store.getters.editPublisherBook.id,  formData, this.upLoadFileToServletCallBack)
                    }
                    else {
                        this.$store.commit('setloginModal', true);
                    }
                }
            },

            upLoadFileToServletCallBack(response) {

                var publisherBooks = this.$store.getters.publisherBooks;

                for (var i = 0; i< publisherBooks.length; i++) {
                    if (publisherBooks[i].id == response.id) {
                        publisherBooks.splice(i,1,response);
                        break;
                    }
                }
                this.$store.commit('setPublisherBooks', publisherBooks);
                this.$store.commit('setEditPublisherBook', response);
                setTimeout(()=> this.$store.commit('setFileUpload', false),3000);
                //this.$store.commit('setFileUpload', false);
            },


            //    show the book in new tab
            showBook(cover){

                var data = this.$store.getters.editPublisherBook;
                if (cover == 1 && data.pathToCover != null ) {
                    var url = data.pathToCover;
                    window.open(utils.containsPathToBook(url,'_blank'));
                }
                else if (cover == 2 && data.pathToBackcover != null) {
                    var url = data.pathToBackcover;
                    window.open(utils.containsPathToBook(url,'_blank'));
                }
                else if (cover == 3 && data.pathToTOC != null) {
                    var url = data.pathToTOC;
                    window.open(utils.containsPathToBook(url,'_blank'));
                }
                else {
                    if (data.pathToChapter != null) {
                        var url = data.pathToChapter;
                        window.open(utils.containsPathToBook(url,'_blank'));
                    }
                }
            },

            //delete file
            deletePathFile(type) {

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    var fileObjc = {
                        bookId: this.$store.getters.editPublisherBook.id,
                        fileToRemove: type
                    };
                    this.$store.commit('setFileUpload', true);
                    this.resetInput(type);
                    request.deletefileFromServer(token, fileObjc, this.upLoadFileToServletCallBack)
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            resetInput(type) {

                switch (type) {

                    case 'cover':
                        this.$refs.pathToCover.reset();
                        break;
                    case 'backcover':
                        this.$refs.pathToBackCover.reset();
                        break;
                    case 'toc':
                        this.$refs.pathToToc.reset();
                        break;
                    default:
                        this.$refs.pathToChapter.reset();

                }
            },

            //    diasble icon
            disableIcon(path){

                return path != null && path != '';
            },

        },

        computed: {

            cover: function () {

                return this.$store.getters.editPublisherBook.pathToCover;
            },

            backCover: function () {

                return this.$store.getters.editPublisherBook.pathToBackcover;
            },

            toToc: function () {

                return this.$store.getters.editPublisherBook.pathToTOC;
            },

            toChapter: function () {

                return this.$store.getters.editPublisherBook.pathToChapter;
            }
        },

        created() {

        }
    }
</script>

<style scoped>

</style>